import { ListContext } from "./chunk-QYTYTHQR.js";
import { __objRest, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/elements/List/List.tsx
import React, { forwardRef, useMemo } from "react";
import clsx from "clsx";
var DEFAULT_COMPONENT = "ul";
var LIST_CLASSNAME_MAP = {
  variant: {
    disc: "pd-list--disc",
    decimal: "pd-list--decimal",
    icon: "pd-list--icon"
  }
};
var List = forwardRef((_a, ref) => {
  var _b = _a,
    {
      as,
      children,
      variant: variantProp,
      icon = "chevron-right",
      className
    } = _b,
    rest = __objRest(_b, ["as", "children", "variant", "icon", "className"]);
  const Component = as || DEFAULT_COMPONENT;
  const variant = useMemo(() => {
    if (!variantProp && Component === "ol") {
      return "decimal";
    }
    return variantProp || "disc";
  }, [Component, variantProp]);
  const context = useMemo(() => ({
    variant,
    icon
  }), [variant, icon]);
  return /* @__PURE__ */React.createElement(ListContext.Provider, {
    value: context
  }, /* @__PURE__ */React.createElement(Component, __spreadValues({
    ref,
    className: clsx("pd-list", LIST_CLASSNAME_MAP.variant[variant], className),
    role: "list"
  }, rest), children));
});
var StoryList = args => /* @__PURE__ */React.createElement(List, __spreadValues({}, args));
var List_default = List;
export { LIST_CLASSNAME_MAP, StoryList, List_default };